import userReducer from './user';

export default {
  user: userReducer,
}


// WEBPACK FOOTER //
// ./src/reducers/index.js